module.exports = __webpack_public_path__ + "static/media/crowdvoting-foerdersummen-visualisierung-inline-rgb.e21fd929.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/crowdvoting-foerdersummen-visualisierung-inline-rgb.svg
// module id = 410
// module chunks = 0